import { render, staticRenderFns } from "./AggregateElementCard.vue?vue&type=template&id=bf0cf832&scoped=true"
import script from "./AggregateElementCard.vue?vue&type=script&lang=js"
export * from "./AggregateElementCard.vue?vue&type=script&lang=js"
import style0 from "./AggregateElementCard.vue?vue&type=style&index=0&id=bf0cf832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0cf832",
  null
  
)

export default component.exports